import React, { useEffect, useState } from 'react'
import {  Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import {  toast } from 'react-toastify';
import { addUser } from '../../services/Users/AddUser'
import { getRoles } from '../../services/Other/GeneralQueries';


function AddUser(){
    const [isLoading, setIsLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        username: '',
        roleId: 0,       
      });

      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
      const redirectBack = () => {
        navigate(`/users`);
      }

      const handleSubmit = (e) => {
        e.preventDefault();    
        console.log(formData)   
        let pendingInputs = [];
        let email = formData.email;
        let userName = formData.username;   
        let roleId = parseInt(formData.roleId);          
        if(!email)
        {
            pendingInputs.push("Email");
        }
        if(!userName)
        {
            pendingInputs.push("Nombre del usuario");
        }
        if(roleId == 0)
        {
            pendingInputs.push("Rol");
        }
        if(pendingInputs.length == 0)
        {
          addUser(email, userName, roleId).then(addUserResult =>{
            if(addUserResult)
            {
                toast.success('Usuario creado correctamente');
                setTimeout(() => {
                    navigate('/users'); // Redirigir después de 3 segundos
                }, 1500); 
            }
            else
            {
              toast.error('Lo sentimos, algo salió mal.');
            }
          })                 
        }
        else
        {
            toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
        }
    }

    useEffect(() => {
      getRoles().then(list=> {
        setRoles(list);
      }).finally(()=> {
        setIsLoading(false);
      })
    }, [])
  return (

    <div>
      { isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (
      
      <Row className='justify-content-center'>
        <Col xl={6}>
        <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail">
          <Form.Label>Email *:</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            
          />
        <h5 className='mt-3'>
        Contraseña por defecto: <Badge bg="secondary">1nV3nt@rio2024</Badge>
      </h5>
        </Form.Group>
        <Form.Group className='mt-3' controlId="formUsername">
          <Form.Label>Username *:</Form.Label>
          <Form.Control
            type="text"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
        
          />
        </Form.Group>

              
        
        <Form.Group className='mt-3' controlId="formRole">
          <Form.Label>Rol *:</Form.Label>
          <Form.Control
            as="select"
            name="roleId"
            value={formData.roleId}
            onChange={handleInputChange}
          >
             <option key={0} value={0}>Seleccionar rol</option>
           {roles.map((role) => (
                <option key={role.id} value={role.id}>{role.name}</option>
              ))}
          </Form.Control>
        </Form.Group>

        <Row>
            <Col xl={12} className='text-center'>
                <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} >
                    Cancelar o regresar
                </Button>
                <Button className='m-3' variant="primary" type="submit">
                    Crear usuario
                </Button>
            </Col>
        </Row>
      </Form>
      </Col>
    </Row>
      )}      
    </div>

   
  );
}

export default AddUser